module.exports = __webpack_public_path__ + "static/media/pocket-calendar.1b7a6adc.jpg";